// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;700&amp;display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
}

:root {
    --mainColor: #edec5b;
    --mainColorLight: #1a1a18;
    --secondaryColor: #1a1a18;
    --textColor: #050505;
    --topBarColor: #edec5b;
    --header-height: 70px;
}

body {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin: 0;
    padding: 0;
    font-family: "Titillium Web", sans-serif;
}

body.white-theme {
    --mainColor: #edec5b;
    --mainColorLight: #1a1a18;
    --secondaryColor: #1a1a18;
    --textColor: #ffffff;
    --topBarColor: #e9c28e;
}

body.dark-theme {
    --mainColor: #edec5b;
    --mainColorLight: #edec5b;
    --secondaryColor: #63b3ed;
    --textColor: #050505;
    --topBarColor: #2d3748;
}

.responsive-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: var(--mainColor);
    color: var(--textColor);
    z-index: 1000;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
    min-height: var(--header-height);
    gap: 15px;
}


.menu-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: var(--textColor);
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 8px;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    min-width: 44px;
    min-height: 44px;
    flex-shrink: 0;
}

.menu-toggle:hover,
.menu-toggle:active {
    background: rgba(255, 255, 255, 0.2);
}

.logo-container {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1;
    cursor: pointer;
}

.header-logo {
    height: 45px;
    width: auto;
    object-fit: contain;
}

.logo-container h2 {
    margin: 0;
    font-size: 1.3rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}


.logout-button {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: var(--textColor);
    cursor: pointer;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    transition: all 0.3s ease;
    font-size: 0.95rem;
    font-weight: 500;
    min-height: 44px;
}

.logout-button:hover,
.logout-button:active {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
}

.logout-button svg {
    font-size: 1.2rem;
}


.main-nav {
    position: fixed;
    top: 0;
    left: -100%;
    width: 85%;
    max-width: 320px;
    height: 100vh;
    background-color: var(--mainColor);
    transition: left 0.3s ease-in-out;
    z-index: 1000;
    overflow-y: auto;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
}

.main-nav.active {
    left: 0;
}


.close-menu-button {
    position: absolute;
    top: 15px;
    right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: var(--textColor);
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 8px;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    min-width: 44px;
    min-height: 44px;
    z-index: 1001;
}

.close-menu-button:hover,
.close-menu-button:active {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.05);
}

.nav-links {
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 70px 1rem 1.5rem 1rem;
    gap: 0.5rem;
    width: 100%;
}

.nav-links li {
    margin: 0;
    position: relative;
    width: 100%;
}

.nav-links a {
    color: var(--textColor);
    text-decoration: none;
    display: flex;
    align-items: center;
    padding: 0.875rem 1rem;
    border-radius: 12px;
    transition: all 0.3s ease;
    gap: 8px;
    font-weight: 500;
    width: 100%;
    justify-content: flex-start;
    -webkit-tap-highlight-color: transparent;
    font-size: 1rem;
}

.nav-links a:hover {
    background-color: rgba(255, 255, 255, 0.15);
    transform: translateY(-1px);
}

.nav-links a:active {
    transform: translateY(0);
    background-color: rgba(255, 255, 255, 0.2);
}

.nav-icon {
    font-size: 1.2rem;
}


.mobile-menu-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    -webkit-backdrop-filter: blur(2px);
            backdrop-filter: blur(2px);
}

.mobile-menu-overlay.active {
    display: block;
}

.login-link {
    color: var(--textColor);
    text-decoration: none;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    background-color: var(--mainColorLight);
    transition: opacity 0.3s;
}

.login-link:hover {
    opacity: 0.8;
}

.content-spacer {
    height: 70px;
}


@media (min-width: 769px) {
    .logo-container {
        max-width: calc(100% - 200px);
    }
    
    .logo-container h2 {
        font-size: 1.1rem;
    }
}


@media (max-width: 768px) {
    .logo-container h2 {
        font-size: 0.9rem;
        max-width: 200px;
    }
    
    .header-logo {
        height: 32px;
    }
    
    .logout-button span {
        display: inline;
    }
}


@media (max-width: 480px) {
    .header-container {
        padding: 0.5rem 1rem;
        gap: 10px;
    }
    
    .logo-container h2 {
        font-size: 0.8rem;
        max-width: 140px;
    }
    
    .header-logo {
        height: 28px;
    }
    
    .main-nav {
        width: 100%;
        max-width: none;
        left: -100%;
    }
    
    .nav-links {
        padding: 70px 1rem 1.5rem 1rem;
    }
    
    .nav-links a {
        padding: 0.75rem 1rem;
        font-size: 0.95rem;
    }
    
    .content-spacer {
        height: 55px;
    }
    
   
    .logout-button span {
        display: none;
    }
    
    .logout-button {
        padding: 0.5rem;
    }
    
    .logout-button svg {
        margin: 0;
    }
}


@supports (-webkit-touch-callout: none) {
    .main-nav {
        -webkit-overflow-scrolling: touch;
    }
    
    .nav-links a {
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0.1);
    }
    
    .menu-toggle,
    .close-menu-button {
        -webkit-tap-highlight-color: transparent;
    }
    
    .main-nav.active {
        height: -webkit-fill-available;
    }
}


@media (hover: none) and (pointer: coarse) {
    .nav-links a {
        padding: 0.75rem 1rem;
        min-height: 44px;
    }
    
    .menu-toggle,
    .logout-button,
    .close-menu-button {
        min-width: 44px;
        min-height: 44px;
    }
}

@supports (-webkit-touch-callout: none) {
    .main-nav {
        -webkit-overflow-scrolling: touch;
        position: fixed;
        top: 0;
        left: -100%;
        width: 85%;
        max-width: 320px;
        height: 100vh;
        height: -webkit-fill-available;
        background-color: var(--mainColor);
        transition: left 0.3s ease-in-out;
        z-index: 1000;
        overflow-y: auto;
        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
    }
    
    .main-nav.active {
        left: 0;
    }
    
    .nav-links a {
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0.1);
        cursor: pointer;
    }
    
   
    .menu-toggle,
    .close-menu-button,
    .logout-button {
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
    }
    
   
    body.menu-open {
        position: fixed;
        width: 100%;
        overflow: hidden;
    }
}

.has-submenu {
    position: relative;
}

.has-submenu > a {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.submenu-icon {
    font-size: 12px;
    margin-left: 8px;
    transition: transform 0.2s;
}

.submenu {
    list-style: none;
    padding-left: 20px;
    margin: 5px 0 0 0;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
}

.submenu li {
    margin: 0;
}

.submenu li a {
    display: block;
    padding: 10px 15px;
    font-size: 14px;
    opacity: 0.9;
    transition: all 0.2s;
}

.submenu li a:hover {
    opacity: 1;
    padding-left: 20px;
}


.dark-theme .submenu {
    background-color: #edec5b;
}


.main-nav {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.nav-links {
    flex: 1 1;
}

.menu-footer {
    margin-top: auto;
    padding: 20px 15px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.dark-theme .menu-footer {
    border-top-color: #edec5b;
}


.menu-footer-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
    color: #000000;
    text-align: left;
}

.dark-theme .menu-footer-title {
    color: #0c0c0c;
}

.menu-footer-contacts {
    display: flex;
    flex-direction: column;
    gap: 8px;
}


.contact-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #000000;
    text-align: left;
    cursor: default;
}

.dark-theme .contact-item {
    color: #0c0c0c;
}

.contact-icon {
    font-size: 14px;
    width: 16px;
    color: #000000;
}

.dark-theme .contact-icon {
    color: #030303;
}


@media (max-width: 768px) {
    .nav-links {
        flex: 1 1;
    }
    
    .menu-footer {
        padding: 15px;
    }
    
    .menu-footer-title {
        font-size: 16px;
    }
    
    .contact-item {
        font-size: 14px;
    }
}

.has-submenu {
    position: relative;
}

.has-submenu > a {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.submenu-icon {
    font-size: 12px;
    margin-left: 8px;
    transition: transform 0.2s;
}

.submenu {
    list-style: none;
    padding-left: 0;
    margin: 5px 0 0 0;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
}

.submenu li {
    margin: 0;
}

.submenu li a {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 15px;
    font-size: 14px;
    opacity: 0.9;
    transition: all 0.2s;
    text-decoration: none;
    color: #000000;
}

.dark-theme .submenu li a {
    color: #000000;
}

.submenu li a:hover {
    opacity: 1;
    padding-left: 20px;
}

.bullet {
    font-size: 16px;
    color: #000000;
    display: inline-block;
}

.dark-theme .bullet {
    color: #000000;
}


.dark-theme .submenu {
    background-color: #edec5b;
}


.main-nav {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.nav-links {
    flex: 1 1;
}

.menu-footer {
    margin-top: auto;
    padding: 20px 15px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.dark-theme .menu-footer {
    border-top-color: rgba(255, 255, 255, 0.1);
}


.menu-footer-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
    color: #000000;
    text-align: left;
}

.dark-theme .menu-footer-title {
    color: #0e0d0d;
}

.menu-footer-contacts {
    display: flex;
    flex-direction: column;
    gap: 8px;
}


.contact-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #000000;
    text-align: left;
    cursor: default;
}

.dark-theme .contact-item {
    color: #0a0a0a;
}

.contact-icon {
    font-size: 14px;
    width: 16px;
    color: #000000;
}

.dark-theme .contact-icon {
    color: #0c0c0c;
}


@media (max-width: 768px) {
    .nav-links {
        flex: 1 1;
    }
    
    .menu-footer {
        padding: 15px;
    }
    
    .menu-footer-title {
        font-size: 16px;
    }
    
    .contact-item {
        font-size: 14px;
    }
    
    .submenu li a {
        padding: 8px 12px;
        font-size: 13px;
    }
    
    .bullet {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;IACT,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,kCAAkC;IAClC,uBAAuB;IACvB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,gCAAgC;IAChC,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,kCAAkC;IAClC,iCAAiC;IACjC,aAAa;IACb,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,OAAO;AACX;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;IAEI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,8BAA8B;IAC9B,WAAW;IACX,WAAW;AACf;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,WAAW;IACX,2BAA2B;IAC3B,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,YAAY;IACZ,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,uCAAuC;IACvC,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;AACJ;;;AAGA;IACI;QACI,iCAAiC;IACrC;;IAEA;QACI,qDAAqD;IACzD;;IAEA;;QAEI,wCAAwC;IAC5C;;IAEA;QACI,8BAA8B;IAClC;AACJ;;;AAGA;IACI;QACI,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;;;QAGI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC,eAAe;QACf,MAAM;QACN,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,kCAAkC;QAClC,iCAAiC;QACjC,aAAa;QACb,gBAAgB;QAChB,yCAAyC;IAC7C;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,qDAAqD;QACrD,eAAe;IACnB;;;IAGA;;;QAGI,eAAe;QACf,wCAAwC;IAC5C;;;IAGA;QACI,eAAe;QACf,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI;QACI,SAAO;IACX;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C;AAC9C;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI;QACI,SAAO;IACX;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;700&amp;display=swap\");\r\n\r\n* {\r\n    box-sizing: border-box;\r\n    -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n:root {\r\n    --mainColor: #edec5b;\r\n    --mainColorLight: #1a1a18;\r\n    --secondaryColor: #1a1a18;\r\n    --textColor: #050505;\r\n    --topBarColor: #edec5b;\r\n    --header-height: 70px;\r\n}\r\n\r\nbody {\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: \"Titillium Web\", sans-serif;\r\n}\r\n\r\nbody.white-theme {\r\n    --mainColor: #edec5b;\r\n    --mainColorLight: #1a1a18;\r\n    --secondaryColor: #1a1a18;\r\n    --textColor: #ffffff;\r\n    --topBarColor: #e9c28e;\r\n}\r\n\r\nbody.dark-theme {\r\n    --mainColor: #edec5b;\r\n    --mainColorLight: #edec5b;\r\n    --secondaryColor: #63b3ed;\r\n    --textColor: #050505;\r\n    --topBarColor: #2d3748;\r\n}\r\n\r\n.responsive-header {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    background-color: var(--mainColor);\r\n    color: var(--textColor);\r\n    z-index: 1000;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.header-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0.5rem 1.5rem;\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n    min-height: var(--header-height);\r\n    gap: 15px;\r\n}\r\n\r\n\r\n.menu-toggle {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    border: none;\r\n    color: var(--textColor);\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n    padding: 0.5rem;\r\n    border-radius: 8px;\r\n    transition: background 0.3s;\r\n    -webkit-tap-highlight-color: transparent;\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.menu-toggle:hover,\r\n.menu-toggle:active {\r\n    background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.logo-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    flex: 1;\r\n    cursor: pointer;\r\n}\r\n\r\n.header-logo {\r\n    height: 45px;\r\n    width: auto;\r\n    object-fit: contain;\r\n}\r\n\r\n.logo-container h2 {\r\n    margin: 0;\r\n    font-size: 1.3rem;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n\r\n.header-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n\r\n.logout-button {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    border: none;\r\n    color: var(--textColor);\r\n    cursor: pointer;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 8px;\r\n    transition: all 0.3s ease;\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n    min-height: 44px;\r\n}\r\n\r\n.logout-button:hover,\r\n.logout-button:active {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.logout-button svg {\r\n    font-size: 1.2rem;\r\n}\r\n\r\n\r\n.main-nav {\r\n    position: fixed;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 85%;\r\n    max-width: 320px;\r\n    height: 100vh;\r\n    background-color: var(--mainColor);\r\n    transition: left 0.3s ease-in-out;\r\n    z-index: 1000;\r\n    overflow-y: auto;\r\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.main-nav.active {\r\n    left: 0;\r\n}\r\n\r\n\r\n.close-menu-button {\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    border: none;\r\n    color: var(--textColor);\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n    padding: 0.5rem;\r\n    border-radius: 8px;\r\n    transition: background 0.3s;\r\n    -webkit-tap-highlight-color: transparent;\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n    z-index: 1001;\r\n}\r\n\r\n.close-menu-button:hover,\r\n.close-menu-button:active {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    transform: scale(1.05);\r\n}\r\n\r\n.nav-links {\r\n    display: flex;\r\n    flex-direction: column;\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 70px 1rem 1.5rem 1rem;\r\n    gap: 0.5rem;\r\n    width: 100%;\r\n}\r\n\r\n.nav-links li {\r\n    margin: 0;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.nav-links a {\r\n    color: var(--textColor);\r\n    text-decoration: none;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0.875rem 1rem;\r\n    border-radius: 12px;\r\n    transition: all 0.3s ease;\r\n    gap: 8px;\r\n    font-weight: 500;\r\n    width: 100%;\r\n    justify-content: flex-start;\r\n    -webkit-tap-highlight-color: transparent;\r\n    font-size: 1rem;\r\n}\r\n\r\n.nav-links a:hover {\r\n    background-color: rgba(255, 255, 255, 0.15);\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.nav-links a:active {\r\n    transform: translateY(0);\r\n    background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.nav-icon {\r\n    font-size: 1.2rem;\r\n}\r\n\r\n\r\n.mobile-menu-overlay {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    z-index: 999;\r\n    backdrop-filter: blur(2px);\r\n}\r\n\r\n.mobile-menu-overlay.active {\r\n    display: block;\r\n}\r\n\r\n.login-link {\r\n    color: var(--textColor);\r\n    text-decoration: none;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 8px;\r\n    background-color: var(--mainColorLight);\r\n    transition: opacity 0.3s;\r\n}\r\n\r\n.login-link:hover {\r\n    opacity: 0.8;\r\n}\r\n\r\n.content-spacer {\r\n    height: 70px;\r\n}\r\n\r\n\r\n@media (min-width: 769px) {\r\n    .logo-container {\r\n        max-width: calc(100% - 200px);\r\n    }\r\n    \r\n    .logo-container h2 {\r\n        font-size: 1.1rem;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n    .logo-container h2 {\r\n        font-size: 0.9rem;\r\n        max-width: 200px;\r\n    }\r\n    \r\n    .header-logo {\r\n        height: 32px;\r\n    }\r\n    \r\n    .logout-button span {\r\n        display: inline;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 480px) {\r\n    .header-container {\r\n        padding: 0.5rem 1rem;\r\n        gap: 10px;\r\n    }\r\n    \r\n    .logo-container h2 {\r\n        font-size: 0.8rem;\r\n        max-width: 140px;\r\n    }\r\n    \r\n    .header-logo {\r\n        height: 28px;\r\n    }\r\n    \r\n    .main-nav {\r\n        width: 100%;\r\n        max-width: none;\r\n        left: -100%;\r\n    }\r\n    \r\n    .nav-links {\r\n        padding: 70px 1rem 1.5rem 1rem;\r\n    }\r\n    \r\n    .nav-links a {\r\n        padding: 0.75rem 1rem;\r\n        font-size: 0.95rem;\r\n    }\r\n    \r\n    .content-spacer {\r\n        height: 55px;\r\n    }\r\n    \r\n   \r\n    .logout-button span {\r\n        display: none;\r\n    }\r\n    \r\n    .logout-button {\r\n        padding: 0.5rem;\r\n    }\r\n    \r\n    .logout-button svg {\r\n        margin: 0;\r\n    }\r\n}\r\n\r\n\r\n@supports (-webkit-touch-callout: none) {\r\n    .main-nav {\r\n        -webkit-overflow-scrolling: touch;\r\n    }\r\n    \r\n    .nav-links a {\r\n        -webkit-tap-highlight-color: rgba(255, 255, 255, 0.1);\r\n    }\r\n    \r\n    .menu-toggle,\r\n    .close-menu-button {\r\n        -webkit-tap-highlight-color: transparent;\r\n    }\r\n    \r\n    .main-nav.active {\r\n        height: -webkit-fill-available;\r\n    }\r\n}\r\n\r\n\r\n@media (hover: none) and (pointer: coarse) {\r\n    .nav-links a {\r\n        padding: 0.75rem 1rem;\r\n        min-height: 44px;\r\n    }\r\n    \r\n    .menu-toggle,\r\n    .logout-button,\r\n    .close-menu-button {\r\n        min-width: 44px;\r\n        min-height: 44px;\r\n    }\r\n}\r\n\r\n@supports (-webkit-touch-callout: none) {\r\n    .main-nav {\r\n        -webkit-overflow-scrolling: touch;\r\n        position: fixed;\r\n        top: 0;\r\n        left: -100%;\r\n        width: 85%;\r\n        max-width: 320px;\r\n        height: 100vh;\r\n        height: -webkit-fill-available;\r\n        background-color: var(--mainColor);\r\n        transition: left 0.3s ease-in-out;\r\n        z-index: 1000;\r\n        overflow-y: auto;\r\n        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);\r\n    }\r\n    \r\n    .main-nav.active {\r\n        left: 0;\r\n    }\r\n    \r\n    .nav-links a {\r\n        -webkit-tap-highlight-color: rgba(255, 255, 255, 0.1);\r\n        cursor: pointer;\r\n    }\r\n    \r\n   \r\n    .menu-toggle,\r\n    .close-menu-button,\r\n    .logout-button {\r\n        cursor: pointer;\r\n        -webkit-tap-highlight-color: transparent;\r\n    }\r\n    \r\n   \r\n    body.menu-open {\r\n        position: fixed;\r\n        width: 100%;\r\n        overflow: hidden;\r\n    }\r\n}\r\n\r\n.has-submenu {\r\n    position: relative;\r\n}\r\n\r\n.has-submenu > a {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.submenu-icon {\r\n    font-size: 12px;\r\n    margin-left: 8px;\r\n    transition: transform 0.2s;\r\n}\r\n\r\n.submenu {\r\n    list-style: none;\r\n    padding-left: 20px;\r\n    margin: 5px 0 0 0;\r\n    background-color: rgba(0, 0, 0, 0.05);\r\n    border-radius: 8px;\r\n}\r\n\r\n.submenu li {\r\n    margin: 0;\r\n}\r\n\r\n.submenu li a {\r\n    display: block;\r\n    padding: 10px 15px;\r\n    font-size: 14px;\r\n    opacity: 0.9;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.submenu li a:hover {\r\n    opacity: 1;\r\n    padding-left: 20px;\r\n}\r\n\r\n\r\n.dark-theme .submenu {\r\n    background-color: #edec5b;\r\n}\r\n\r\n\r\n.main-nav {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n.nav-links {\r\n    flex: 1;\r\n}\r\n\r\n.menu-footer {\r\n    margin-top: auto;\r\n    padding: 20px 15px;\r\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.dark-theme .menu-footer {\r\n    border-top-color: #edec5b;\r\n}\r\n\r\n\r\n.menu-footer-title {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    margin-bottom: 12px;\r\n    color: #000000;\r\n    text-align: left;\r\n}\r\n\r\n.dark-theme .menu-footer-title {\r\n    color: #0c0c0c;\r\n}\r\n\r\n.menu-footer-contacts {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n\r\n.contact-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    font-size: 14px;\r\n    color: #000000;\r\n    text-align: left;\r\n    cursor: default;\r\n}\r\n\r\n.dark-theme .contact-item {\r\n    color: #0c0c0c;\r\n}\r\n\r\n.contact-icon {\r\n    font-size: 14px;\r\n    width: 16px;\r\n    color: #000000;\r\n}\r\n\r\n.dark-theme .contact-icon {\r\n    color: #030303;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n    .nav-links {\r\n        flex: 1;\r\n    }\r\n    \r\n    .menu-footer {\r\n        padding: 15px;\r\n    }\r\n    \r\n    .menu-footer-title {\r\n        font-size: 16px;\r\n    }\r\n    \r\n    .contact-item {\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n.has-submenu {\r\n    position: relative;\r\n}\r\n\r\n.has-submenu > a {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.submenu-icon {\r\n    font-size: 12px;\r\n    margin-left: 8px;\r\n    transition: transform 0.2s;\r\n}\r\n\r\n.submenu {\r\n    list-style: none;\r\n    padding-left: 0;\r\n    margin: 5px 0 0 0;\r\n    background-color: rgba(0, 0, 0, 0.05);\r\n    border-radius: 8px;\r\n}\r\n\r\n.submenu li {\r\n    margin: 0;\r\n}\r\n\r\n.submenu li a {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 10px 15px;\r\n    font-size: 14px;\r\n    opacity: 0.9;\r\n    transition: all 0.2s;\r\n    text-decoration: none;\r\n    color: #000000;\r\n}\r\n\r\n.dark-theme .submenu li a {\r\n    color: #000000;\r\n}\r\n\r\n.submenu li a:hover {\r\n    opacity: 1;\r\n    padding-left: 20px;\r\n}\r\n\r\n.bullet {\r\n    font-size: 16px;\r\n    color: #000000;\r\n    display: inline-block;\r\n}\r\n\r\n.dark-theme .bullet {\r\n    color: #000000;\r\n}\r\n\r\n\r\n.dark-theme .submenu {\r\n    background-color: #edec5b;\r\n}\r\n\r\n\r\n.main-nav {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n.nav-links {\r\n    flex: 1;\r\n}\r\n\r\n.menu-footer {\r\n    margin-top: auto;\r\n    padding: 20px 15px;\r\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.dark-theme .menu-footer {\r\n    border-top-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n\r\n.menu-footer-title {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    margin-bottom: 12px;\r\n    color: #000000;\r\n    text-align: left;\r\n}\r\n\r\n.dark-theme .menu-footer-title {\r\n    color: #0e0d0d;\r\n}\r\n\r\n.menu-footer-contacts {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n\r\n.contact-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    font-size: 14px;\r\n    color: #000000;\r\n    text-align: left;\r\n    cursor: default;\r\n}\r\n\r\n.dark-theme .contact-item {\r\n    color: #0a0a0a;\r\n}\r\n\r\n.contact-icon {\r\n    font-size: 14px;\r\n    width: 16px;\r\n    color: #000000;\r\n}\r\n\r\n.dark-theme .contact-icon {\r\n    color: #0c0c0c;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n    .nav-links {\r\n        flex: 1;\r\n    }\r\n    \r\n    .menu-footer {\r\n        padding: 15px;\r\n    }\r\n    \r\n    .menu-footer-title {\r\n        font-size: 16px;\r\n    }\r\n    \r\n    .contact-item {\r\n        font-size: 14px;\r\n    }\r\n    \r\n    .submenu li a {\r\n        padding: 8px 12px;\r\n        font-size: 13px;\r\n    }\r\n    \r\n    .bullet {\r\n        font-size: 14px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
